var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1677,
    viewBox: "0 0 1512 1677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 23,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint0_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 48,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint1_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 73,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint2_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 98,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint3_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 123,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint4_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 173,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint5_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 198,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint6_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 223,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint7_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 248,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint8_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 273,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint9_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 298,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint10_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 323,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint11_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 348,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint12_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 373,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint13_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 398,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint14_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 423,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint15_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 448,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint16_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 473,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint17_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 498,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint18_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 523,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint19_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 548,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint20_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 573,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint21_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 598,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint22_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 148,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint23_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 598,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint24_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 623,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint25_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 648,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint26_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 673,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint27_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 698,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint28_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 723,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint29_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 748,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint30_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 773,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint31_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 798,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint32_linear_414_2510)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 851.943,
    r: 823,
    transform: "rotate(180 756 851.943)",
    stroke: "url(#paint33_linear_414_2510)",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_2510",
    x1: 756,
    y1: 826.943,
    x2: 756,
    y2: 876.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_2510",
    x1: 756,
    y1: 801.943,
    x2: 756,
    y2: 901.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_414_2510",
    x1: 756,
    y1: 776.943,
    x2: 756,
    y2: 926.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_414_2510",
    x1: 756,
    y1: 751.943,
    x2: 756,
    y2: 951.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_414_2510",
    x1: 756,
    y1: 726.943,
    x2: 756,
    y2: 976.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_414_2510",
    x1: 756,
    y1: 676.943,
    x2: 756,
    y2: 1026.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_414_2510",
    x1: 756,
    y1: 651.943,
    x2: 756,
    y2: 1051.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_414_2510",
    x1: 756,
    y1: 626.943,
    x2: 756,
    y2: 1076.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_414_2510",
    x1: 756,
    y1: 601.943,
    x2: 756,
    y2: 1101.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_414_2510",
    x1: 756,
    y1: 576.943,
    x2: 756,
    y2: 1126.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_414_2510",
    x1: 756,
    y1: 551.943,
    x2: 756,
    y2: 1151.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_414_2510",
    x1: 756,
    y1: 526.943,
    x2: 756,
    y2: 1176.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_414_2510",
    x1: 756,
    y1: 501.943,
    x2: 756,
    y2: 1201.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_414_2510",
    x1: 756,
    y1: 476.943,
    x2: 756,
    y2: 1226.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_414_2510",
    x1: 756,
    y1: 451.943,
    x2: 756,
    y2: 1251.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_414_2510",
    x1: 756,
    y1: 426.943,
    x2: 756,
    y2: 1276.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_414_2510",
    x1: 756,
    y1: 401.943,
    x2: 756,
    y2: 1301.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_414_2510",
    x1: 756,
    y1: 376.943,
    x2: 756,
    y2: 1326.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_414_2510",
    x1: 756,
    y1: 351.943,
    x2: 756,
    y2: 1351.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_414_2510",
    x1: 756,
    y1: 326.943,
    x2: 756,
    y2: 1376.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_414_2510",
    x1: 756,
    y1: 301.943,
    x2: 756,
    y2: 1401.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_414_2510",
    x1: 756,
    y1: 276.943,
    x2: 756,
    y2: 1426.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_414_2510",
    x1: 756,
    y1: 251.943,
    x2: 756,
    y2: 1451.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_414_2510",
    x1: 756,
    y1: 701.943,
    x2: 756,
    y2: 1001.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_414_2510",
    x1: 756,
    y1: 251.943,
    x2: 756,
    y2: 1451.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_414_2510",
    x1: 756,
    y1: 226.943,
    x2: 756,
    y2: 1476.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_414_2510",
    x1: 756,
    y1: 201.943,
    x2: 756,
    y2: 1501.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_414_2510",
    x1: 756,
    y1: 176.943,
    x2: 756,
    y2: 1526.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_414_2510",
    x1: 756,
    y1: 151.943,
    x2: 756,
    y2: 1551.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_414_2510",
    x1: 756,
    y1: 126.943,
    x2: 756,
    y2: 1576.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_414_2510",
    x1: 756,
    y1: 101.943,
    x2: 756,
    y2: 1601.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_414_2510",
    x1: 756,
    y1: 76.9434,
    x2: 756,
    y2: 1626.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_414_2510",
    x1: 756,
    y1: 51.9434,
    x2: 756,
    y2: 1651.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_414_2510",
    x1: 756,
    y1: 26.9434,
    x2: 756,
    y2: 1676.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#6B2AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD612E",
    stopOpacity: 0.16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.ce8bebfc545bbf2c5f4e4a8dede9e38d.svg";
export { ForwardRef as ReactComponent };